import { gql } from 'apollo-angular';

export const QueryNotes = gql`
  query Notes($filter: FilterInput) {
    notes(filter: $filter) {
      id
      createdAt
      editedAt
      createdBy
      editedBy
      text
    }
  }
`;

export const CreateNote = gql`
  mutation createCustomerNote($input: CreateNoteInput!) {
    createNote(createNoteInput: $input) {
      id
      createdAt
      editedAt
      createdBy
      editedBy
      text
    }
  }
`;

export const RemoveNote = gql`
  mutation removeCustomerNote($note_id: String!) {
    removeNote(id: $note_id) {
      id
    }
  }
`;

export const EditNote = gql`
  mutation editCustomerNote($input: UpdateNoteInput!) {
    updateNote(updateNoteInput: $input) {
      id
      createdAt
      editedAt
      createdBy
      editedBy
      text
    }
  }
`;
